<!-- <div class="container d-flex justify-content-center align-items-center vh-100">
  <div class="card p-4 shadow" style="width: auto; max-width: 400px;">
    <h4 class="text-center mb-3">OTP Verification</h4>
    <p class="text-center text-muted">Enter the code that sent to your email</p>
    
    <div class="otp-container mb-4">
      <div *ngFor="let digit of otp; let i = index" class="otp-input">
        <input
          type="text"
      [value]="otp[i]"
      (input)="onInput($event, i)"
          (keydown)="onKeyDown($event, i)"
          (paste)="onPaste($event)"
          (focus)="activeInput = i"
          maxlength="1"
          [class.is-invalid]="error"
          [class.active]="activeInput === i"
          #otpInput
        >
      </div>
    </div>
    
    <div *ngIf="error" class="alert alert-danger text-center">
      Invalid OTP. Please try again.
    </div>
  </div>
</div> -->


<form [formGroup]="otpForm" >
  <div class="container d-flex justify-content-center align-items-center vh-100">
    <div class="card p-4 shadow" style="width: auto; max-width: 400px;">
      <h4 class="text-center mb-3">OTP Verification</h4>
      <p class="text-center text-muted">Enter the code that sent to your email</p>
      
      <div class="otp-container mb-4" formArrayName="code">
        <div *ngFor="let control of codeControls; let i = index" class="otp-input">
          <input
            type="text"
            maxlength="1"
            [formControlName]="i"
            (input)="onInput($event, i)"
            (keydown)="onKeyDown($event, i)"
            (paste)="onPaste($event)"
            [class.is-invalid]="error"
            [class.active]="activeInput === i"
            #otpInput
          />
        </div>
      </div>

      <div *ngIf="error" class="alert alert-danger text-center">
        Invalid OTP. Please try again.
      </div>
    </div>
  </div>
</form>

